module.exports = "thead tr th {\n  cursor: pointer; }\n  thead tr th:hover .sort-indicator .fa-sort {\n    display: inline; }\n  thead tr th:hover .sort-indicator .empty-placeholder {\n    display: none; }\n\ntfoot tr th {\n  border-top: 2px solid #e9ecef; }\n\n.sort-indicator .fa-sort {\n  display: none; }\n\n.sort-indicator .empty-placeholder {\n  width: 0.625em;\n  display: inline-block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/statistics/userPerformance/userPerformance.component.scss
// module id = 594
// module chunks = 1